const airQualityTables = document.querySelector('.air-quality-table');

if (airQualityTables) {
  const API_URL = '/ajax-api/?action=airQuality';

  const fmt = (v) => v?.toString().replace('.', ',') ?? '';

  const dateFmt = new Intl.DateTimeFormat('sl-SI', {
    day: 'numeric',
    month: 'numeric',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
  const fmtDate = (iso) => dateFmt.format(new Date(iso));

  const WEATHER_FIELDS = [
    'temperature',
    'humidity',
    'pressure',
    'precipitation',
    'precipitation_intensity',
    'wind_speed',
    'wind_vertical_speed',
    'wind_direction',
  ];

  const rowHtml = ({ station, pm25, pm10, so2, no2 }) => `
  <div class="air-quality-table__table-row">
    <div class="air-quality-table__table-item">
      <i data-component="at-icon" class="icon : icon-pin"></i>
      <span>${station}</span>
    </div>
    ${[pm25, pm10, so2, no2]
      .map((v) => `<div class="air-quality-table__table-item"><span>${fmt(v)}</span></div>`)
      .join('')}
  </div>`;

  const updateTable = (card, rows) => {
    const finalRow = card.querySelector('.air-quality-table__table-row.final-row');
    card
      .querySelectorAll('.air-quality-table__table-row:not(.first-row):not(.final-row)')
      .forEach((row) => row.remove());
    finalRow.insertAdjacentHTML('beforebegin', rows.map(rowHtml).join(''));
  };

  const updateAirQuality = async () => {
    const data = await fetch(API_URL).then((res) => res.json());
    const [hourlyCard, dailyCard] = airQualityTables.querySelectorAll('.air-quality-table__card');

    updateTable(hourlyCard, data.hourly.rows);
    updateTable(dailyCard, data.daily.rows);

    hourlyCard.querySelector('.air-quality-table__card-text span').textContent = data.hourly.period_label ?? '';
    dailyCard.querySelector('.air-quality-table__card-text span').textContent = data.daily.period_label ?? '';

    airQualityTables.querySelector('.air-quality-table__bottom-info__text span').textContent = fmtDate(
      data.generated_at,
    );

    airQualityTables.querySelectorAll('.air-quality-table__bottom-info__card').forEach((card, i) => {
      const value = card.querySelector('.air-quality-table__bottom-info__card-value span');
      if (value) value.textContent = fmt(data.weather.current[WEATHER_FIELDS[i]]);
    });
  };

  updateAirQuality();
  setInterval(updateAirQuality, 10 * 60 * 1000);
}
